/*
 * Map is used to map credit card brand names to file names stored at //public/static/img/card-icons/placeholder
 */
export const CreditCardBrandNamesToFileNameMap = {
  AMX: ['AMX', 'amex'],
  'card-empty': ['unknown', 'card-empty'],
  CUP: ['CUP', 'unionpay'],
  DIN: ['DIN', 'diners'],
  DIS: ['DIS', 'discover'],
  DNK: ['DNK'],
  ECA: ['ECA', 'mastercard'],
  ELO: ['ELO'],
  JCB: ['JCB', 'jcb'],
  MAU: ['MAU'],
  UAP: ['UAP'],
  VIS: ['VIS', 'visa', 'VISA'],
  VPY: ['VPY'],
};

export const DIGITAL_WALLET_TYPE = {
  OLO: 'olo',
  STRIPE: 'stripe',
  SQUARE: 'square',
};

export const PAYMENT_PROVIDER = {
  STRIPE: 'stripe',
  TOAST: 'toast',
  SQUARE: 'square',
} as const;

export const DIGITAL_WALLET_NAME = {
  GOOGLE_PAY: 'google_pay',
  APPLE_PAY: 'apple_pay',
} as const;

export const FORM_STEP = {
  GUEST: 'guestForm',
  CARD: 'cardForm',
} as const;
